import { ILocationService } from 'angular';
import { AssetTypeCollection } from 'app/shared/collections/asset_type_collection.service';
import Constant from './utilities/constant';

export type IndicatorIconType =
    | 'base_icon'
    | 'circle_crossed_out'
    | 'square'
    | 'delay_code'
    | 'exclamation_mark'
    | 'star'
    | 'mob'
    | 'generator';

const INDICATOR_ICONS_BY_TYPE: { [P in IndicatorIconType]: string } = {
    base_icon: 'indicators/base_icon',
    circle_crossed_out: 'indicators/circle_crossed_out',
    square: 'indicators/square',
    delay_code: 'indicators/red_dot',
    exclamation_mark: 'indicators/exclamation_mark',
    star: 'indicators/star',
    mob: 'mob',
    generator: 'generator',
};

export class ImageUrlService {
    _$location;
    _assetTypeCollection;

    /**
     * This services creates image url strings from ims object ids
     */
    constructor($location: ILocationService, assetTypeCollection: AssetTypeCollection) {
        this._$location = $location;
        this._assetTypeCollection = assetTypeCollection;
    }

    getUrl(group, id, image_type, full_url = null) {
        switch (image_type) {
            case 'svg':
                image_type = '.svg';
                break;
            case 'png':
                image_type = '.png';
                break;
            default:
                image_type = '';
        }

        let prefix = '';
        if (full_url) {
            prefix =
                this._$location.$$protocol +
                '://' +
                this._$location.$$host +
                ':' +
                this._$location.$$port +
                this._$location.$$path;
            if (prefix[prefix.length - 1] === '/') {
                prefix = prefix.substring(0, prefix.length - 1);
            }
        }

        if (group === 'asset_type') {
            return this._getAssetType(id, image_type, prefix);
        } else if (group === 'indicator') {
            return this._getIndicator(id, image_type, prefix);
        } else if (group === 'selection') {
            return this._getSelectionRing(prefix);
        } else if (group === 'transmitter') {
            return this._getTransmitter(prefix);
        } else {
            throw 'No group found or provided';
        }
    }

    _getTransmitter(prefix): string {
        return prefix + Constant.URL.MAP_ICONS_URL + 'transmitter.png';
    }

    _getIndicator(id, image_type, prefix): string {
        const imageName = INDICATOR_ICONS_BY_TYPE[id];
        if (!imageName) {
            throw 'No indicator found with id: ' + id;
        }
        return prefix + Constant.URL.MAP_ICONS_URL + imageName + image_type;
    }

    _getAssetType(id, image_type, prefix): string {
        const imageName = this._assetTypeCollection.get(id).image_name;
        return prefix + Constant.URL.MAP_ICONS_URL + imageName + image_type;
    }

    _getSelectionRing(prefix): string {
        return prefix + Constant.URL.MAP_ICONS_URL + 'container/selection_ring.png';
    }
}
